__turbopack_context__.v({
  "headerWrapper": "FilterPanelHeader-module-scss-module__NFhdWW__headerWrapper",
});
